import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useTenant } from "hooks/useTenant";
import { OrganizationTable } from "routes/Staff/Implementation/OrganizationTable";

export function Organizations() {
  const { tenantId } = useTenant();

  useBreadcrumb({
    label: "Organizations",
    to: `/o/${tenantId}/organizations`,
  });

  return <OrganizationTable />;
}
